import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesTypesMigrateRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-types-migrate',
	path: '/secure/admin/MigrateIssueTypes([!%]?[\\w]*).jspa',
};
